import { useStateContext } from '../context/ContextProvider';
const Button = ({icon, bgColor, color, bgHoverColor, size, text, borderRadius, width }) => {
  const { setIsClicked } = useStateContext();
  return (
    <button
      type="button"
      onClick={() => setIsClicked(false)}
      style={{
        backgroundColor: bgColor,
        color: color,
        borderRadius: borderRadius,
      }}
      className={`text-${size} w-${width} p-3 hover:drop-shadow-xl hover:bg-${bgHoverColor}`}
    >
      {icon} {text}
    </button>
  );
};

export default Button;
